import { SSN_FORMAT } from '../../constants';
import { SSN_CAPTURING_GROUPS } from '../../constants/regexes';
export function formatSSN(value) {
    return String(value)
        .replace(/\D/g, '')
        .slice(0, 9)
        .replace(SSN_CAPTURING_GROUPS, SSN_FORMAT);
}
//# sourceMappingURL=format-ssn.js.map